.atm_40_1fz0aif{border-bottom:1px solid #CED3DA;}
.atm_l8_ejg8kd{padding:16px 8px;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_9s_1txwivl{display:flex;}
.atm_fc_1yb4nlp.atm_fc_1yb4nlp{justify-content:space-between;}
.atm_gi_idpfg4{margin:0;}
.atm_h0_ftgil2.atm_h0_ftgil2{margin-right:8px;}
.atm_3f_glywfm{border:none;}
.atm_c8_1j6vyhq.atm_c8_1j6vyhq{font-size:1rem;}
.atm_gi_ftgil2{margin:8px;}
.atm_kd_glywfm{outline:none;}
.atm_my_glywfm{resize:none;}
.atm_vy_1osqo2v{width:100%;}
.atm_n1gy25_6s2ej5::placeholder{color:#424952;}
.atm_l8_1y44olf{padding:4px;}
.atm_gz_ftgil2.atm_gz_ftgil2{margin-left:8px;}
